"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/hooks/use-auth";
import { cn } from "@/utils/cn";
import React from "react";
import { HeroCarousel } from "./hero-carousel";
import { DynamicHeroPreferencesSection } from "./lazy-client-components";
import { SearchSection } from "./search";
const statistics = [{
  value: <>
				<span className="text-base">₹</span>
				<span>2,000</span>
			</>,
  suffix: "cr+",
  label: "Worth homes sold"
}, {
  value: "8,000",
  suffix: "+",
  label: "Satisfied customers"
}, {
  value: "2 Lakh",
  suffix: "+",
  label: "Professional visits"
}, {
  value: "4.6",
  suffix: "/5",
  label: "Google ratings"
}];
export const HeroSection: React.FC = () => {
  const $ = _c(18);
  const {
    isAuthenticated,
    isLoading: authLoading
  } = useAuth();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: "90dvw",
      transform: "translateX(calc(50dvw - 50%)) translateZ(0)",
      color: "oklch(var(--accent) / 0.4)",
      willChange: "auto"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute top-0 right-0 h-[300px] sm:h-[400px] md:h-[500px] lg:h-full z-10 pointer-events-none transform-gpu" style={t0}><svg xmlns="http://www.w3.org/2000/svg" width="995" height="761" viewBox="0 0 995 761" fill="currentColor" className="absolute top-0 right-0 w-auto h-full min-w-[400px] md:min-w-[600px] lg:min-w-[995px]" preserveAspectRatio="xMaxYMin meet"><path opacity="0.7" d="M242 294C-13.6122 245.186 -23.1432 98.5289 19.7281 0H995V760.5C758 760.5 567 702 497 584.5C427 467 497.613 342.814 242 294Z" /></svg></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-4 md:mb-6"><h1 className={cn("text-3xl md:text-5xl font-semibold leading-tight md:leading-none mb-2 text-center md:text-left", "bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent", "animate-[fade-in-up_0.8s_ease-out_forwards]")}>Buy or Sell</h1><h2 className={cn("text-xl md:text-2xl font-semibold text-foreground leading-tight md:leading-none text-center md:text-left", "animate-[fade-in-up_1s_ease-out_forwards]")}>property easily with Settlin</h2></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-xs text-primary-700/80 font-normal">-</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-base md:text-lg font-bold mb-6 max-w-[635px] text-center md:text-left"><span className="text-primary-700">Settl{t3}in or Settl<span className="text-xs text-primary-700/80 font-normal">-</span>it.{" "}</span><span className="text-foreground">Search to Sale-deed</span></p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="block md:hidden w-full"><HeroCarousel /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = !authLoading && isAuthenticated;
  let t7;
  if ($[6] !== t6) {
    t7 = <div className="mb-8"><SearchSection isLoggedIn={t6} /></div>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== authLoading || $[9] !== isAuthenticated) {
    t8 = !authLoading && isAuthenticated && <div className="mb-8"><DynamicHeroPreferencesSection /></div>;
    $[8] = authLoading;
    $[9] = isAuthenticated;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mb-8 -z-10" id="statistics"><div className="grid grid-cols-2 xl:grid-cols-4 gap-3 md:gap-6 xl:gap-6">{statistics.map(_temp)}</div></div>;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t7 || $[13] !== t8) {
    t10 = <div className="flex flex-col h-full flex-1 pt-4 md:pt-12 lg:pt-16"><div className="flex-1 flex flex-col relative z-40">{t2}{t4}{t5}{t7}{t8}{t9}</div></div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="hidden md:flex flex-1 flex-col max-w-[600px] align-center pt-4 md:pt-12 lg:pt-16"><HeroCarousel /></div>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10) {
    t12 = <section className="w-full min-h-[calc(100vh-64px)] md:min-h-[calc(100vh-80px)] bg-background mx-auto overflow-hidden transform-gpu">{t1}<div className="relative z-30 h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-8 flex flex-col md:flex-row md:items-start md:gap-8">{t10}{t11}</div></section>;
    $[16] = t10;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
};
function _temp(stat, index) {
  return <div key={index} className="text-center md:text-left transform-gpu" role="group" aria-label={stat.label}><div className="flex items-baseline justify-center md:justify-start"><div className="flex items-baseline whitespace-nowrap"><span className="text-2xl sm:text-3xl font-bold text-foreground">{stat.value}</span><span className="text-sm sm:text-base font-bold text-primary-700 ml-1">{stat.suffix}</span></div></div><p className="text-xs sm:text-sm text-foreground mt-1 md:mt-2 leading-tight">{stat.label}</p></div>;
}